import { generatePair, seededRandom } from "@synapse/engine";
import type { GraphData } from "../types/gameTypes";
import type { DailyChallenge } from "../types/dailyChallenges";

/** Deterministic [0,1) RNG seeded from a string; lives in @synapse/engine. */
export { seededRandom };

export interface ChallengeSelector {
  /** Deterministically pick the daily challenge for `date` from `graph`. */
  select(date: string, graph: GraphData): DailyChallenge | null;
}

/**
 * Baseline selector: date-seeded pair from the shared pair generator. The pair
 * for a date depends only on the date and the graph; golden tests pin it.
 * `optimalPathLength` is par and `aiSolution.path` is the gold path (best
 * route: fewest hops, then least distance); legacy key names, Ruling R9.
 */
export class DeterministicSelector implements ChallengeSelector {
  select(date: string, graph: GraphData): DailyChallenge | null {
    const pair = generatePair(graph, { rng: seededRandom(date) });
    if (!pair || pair.path.length < 2) return null;
    const { start, end, path } = pair;
    return {
      id: date,
      date,
      startWord: start,
      targetWord: end,
      optimalPathLength: path.length - 1,
      aiSolution: { path, stepsTaken: path.length - 1, model: "deterministic" },
    };
  }
}
